import type { MessageKey } from "./ru"

export const uzMessages = {
  "common.loading": "Yuklanmoqda...",
  "common.error": "Xato",
  "common.back": "Orqaga",
  "common.next": "Keyingi",
  "common.search": "Qidiruv",
  "auth.loginErrorTitle": "Kirish xatosi",
  "auth.openViaTelegram": "Ilovani Telegram orqali oching",
  "auth.telegramRequired": "Ilova Telegram orqali ochilishi kerak",
  "auth.authorizationError": "Avtorizatsiya xatosi",
  "device.rotatePortrait": "Qurilmani tik holatga o‘giring",
  "country.brazil": "Braziliya",
  "country.vietnam": "Vyetnam",
  "country.egypt": "Misr",
  "country.india": "Hindiston",
  "country.indonesia": "Indoneziya",
  "country.iran": "Eron",
  "country.spain": "Ispaniya",
  "country.italy": "Italiya",
  "country.kazakhstan": "Qozog‘iston",
  "country.colombia": "Kolumbiya",
  "country.malaysia": "Malayziya",
  "country.mexico": "Meksika",
  "country.nigeria": "Nigeriya",
  "country.pakistan": "Pokiston",
  "country.russia": "Rossiya",
  "country.usa": "AQSH",
  "country.turkey": "Turkiya",
  "country.uzbekistan": "O‘zbekiston",
  "country.ukraine": "Ukraina",
  "country.philippines": "Filippin",
  "countrySelection.chooseCountry": "Mamlakatni tanlang",
  "countrySelection.openAria": "Mamlakatni tanlash",
  "languageSelection.chooseLanguage": "Tilni tanlang",
  "commercial.direction.autotrade": "Avto bozor",
  "commercial.direction.insurance": "Sug‘urta",
  "commercial.direction.pitstop": "Pit-stop",
  "commercial.direction.techhelp": "Yo‘l yordami",
  "commercial.searchLabel": "BeepApp qidiruvi",
  "commercial.cityPlaceholder": "Shaharni kiriting",
  "commercial.emptyTitle": "Bugun takliflar yo‘q",
  "commercial.emptyLine1": "Shahringizda hali faol BeepApp hamkorlari yo‘q",
  "commercial.emptyLine2": "Biz ularni topish va ulash ustida ishlayapmiz",
  "commercial.emptyLine3": "Yangi takliflar bu yerda avtomatik paydo bo‘ladi",
  "commercial.helperLine1": "Mavjud takliflarni ko‘rish uchun",
  "commercial.helperLine2": "shahringizni kiriting",
  "commercial.partnerPrompt": "BeepApp hamkori bo‘lishni xohlaysizmi?",
  "commercial.apply": "Ariza yuborish",
  "main.admin": "Admin",
  "main.garage": "Garaj",
  "main.signalSent": "Signal yuborildi",
  "main.partnerInviteUnavailable": "Hamkorlik taklifi mavjud emas",
  "main.enterPlate": "Davlat raqamini kiriting",
  "main.searchError": "Qidiruv xatosi",
  "main.signalSendError": "Signalni yuborib bo‘lmadi",
  "main.shareCardPrefix": "Raqam kartasi",
  "main.shareLinkError": "Havolani tayyorlab bo‘lmadi",
  "main.searchByPlateAria": "Davlat raqami bo‘yicha qidiruv",
  "main.russianPlateAria": "Rossiya davlat raqami",
  "main.plateAria": "Davlat raqami",
  "main.findPlateAria": "Raqamni topish",
  "main.loadingVehicle": "Raqam kartasi yuklanmoqda…",
  "main.leaveSignal": "Signal qoldirish",
  "main.share": "Ulashish",
  "signalSelection.chooseType": "Signal turini tanlang",
  "signalSelection.category.attention": "Shaxsiy",
  "signalSelection.category.road": "Yo‘l",
  "signalSelection.category.urgent": "Shoshilinch",
  "signalSelection.chooseSignal": "Signalni tanlang",
  "signalSelection.suggestOwn": "O‘z variantingizni taklif qiling",
  "signalConfirmation.title": "Signalni tasdiqlash",
  "signalConfirmation.plateHeading": "Avtomobil raqamini tekshiring",
  "signalConfirmation.signalHeading": "Tanlangan signalni tekshiring",
  "signalConfirmation.replyTitle": "Telegram orqali javobga ruxsat berish",
  "signalConfirmation.replyBody": "Bu funksiyani yoqsangiz, raqam egasi sizga\nTelegram orqali yozishi mumkin. Javob faqat sizda\n@username bo‘lsa mumkin. Javob berish qarori\nraqam egasida qoladi.",
  "signalConfirmation.consentText": "Signal haqiqiy vaziyatga mosligini\nva spam yoki yolg‘on xabar emasligini\ntasdiqlayman.",
  "signalConfirmation.warning": "Yuborilgandan keyin signalni\no‘zgartirib bo‘lmaydi",
  "signalConfirmation.sending": "Yuborilmoqda…",
  "signalConfirmation.send": "Yuborish",
  "partner.loadingAria": "Yuklanmoqda",
  "partner.title": "Hamkorlik dasturi",
  "partner.offerLine1": "Taklif qilgan foydalanuvchilaringiz to‘lovlaridan",
  "partner.offerLine2": "muddatsiz 30% daromad oling",
  "partner.offerLine3": "Telegram affiliate dasturi orqali",
  "partner.connectUnavailable": "Ulanish Telegram Affiliate dasturi sozlangandan so‘ng mavjud bo‘ladi.",
  "partner.connectTelegram": "Telegram orqali ulanish",
  "partner.qrAria": "Hamkorlik havolasi QR-kodi",
  "partner.download": "Yuklab olish",
  "partner.promoHeading": "Shaxsiy promo-kod yarating",
  "partner.promoHelperLine1": "Promo-kod qo‘shimcha bir yillik obunani faollashtiradi",
  "partner.promoHelperLine2": "va foydalanuvchilarni jalb qilishga yordam beradi",
  "partner.promoAria": "Promo-kod",
  "partner.affiliateHeading": "Affiliate havolangiz",
  "partner.affiliateHelper": "Shaxsiy QR-kod yaratish uchun havolani saqlang",
  "partner.affiliateAria": "Affiliate havola",
  "partner.qrNoteLine1": "QR-kodni avtomobilingizga,",
  "partner.qrNoteLine2": "ijtimoiy tarmoqlarga va reklama materiallariga joylashtirish mumkin",
  "partner.save": "Saqlash",
  "partner.reset": "Tiklash",
  "partner.resetConfirm": "Saqlangan affiliate havola tiklansinmi? Promo-kod sizda qoladi.",
  "partner.promoFormatError": "Promo-kod 4 dan 15 tagacha belgidan iborat bo‘lishi kerak.",
  "partner.affiliateHostError": "Faqat t.me yoki telegram.me havolalariga ruxsat beriladi.",
  "partner.affiliatePathError": "Havolada Telegram yo‘li mavjud emas.",
  "partner.affiliateFormatError": "Noto‘g‘ri affiliate havola.",
  "partner.loadError": "Yuklash xatosi",
  "partner.checkInputError": "Kiritilgan ma’lumotlarni tekshiring",
  "garageActivation.promoInvalid": "Promo-kod yaroqsiz",
  "garageActivation.plateOccupied": "Bu davlat raqami allaqachon bog‘langan",
  "garageActivation.activateError": "Garajni faollashtirib bo‘lmadi",
  "garageEntry.loadJournalError": "Jurnalni yuklab bo‘lmadi",
  "garageEntry.loadStatusesError": "Statuslarni yuklab bo‘lmadi",
  "garageEntry.activationSuccess": "Garaj muvaffaqiyatli faollashtirildi",
  "garageEntry.plateAttached": "Raqam bog‘landi",
  "garageEntry.attachError": "Raqamni bog‘lab bo‘lmadi",
  "garageEntry.activationNote": "Garajingizni faollashtiring",
  "garageSheet.activationTitle": "Garajni faollashtirish",
  "garageSheet.plateHelper": "Avtomobil davlat raqamini kiriting",
  "garageSheet.promoHelper": "Promo-kodingiz bormi?",
  "garageSheet.cleanBonusLine1": "Faollashtirgandan so‘ng sizda 1 soat bo‘ladi",
  "garageSheet.cleanBonusLine2": "bepul “Toza start” uchun",
  "garageSheet.activationFor": "Faollashtirish muddati",
  "garageSheet.cost": "Narxi",
  "garageSheet.ownerConsentLine1": "Ko‘rsatilgan davlat raqamli",
  "garageSheet.ownerConsentLine2": "transport vositasining egasi ekanligimni",
  "garageSheet.ownerConsentLine3": "tasdiqlayman.",
  "garageSheet.processing": "Bajarilmoqda...",
  "garageSheet.attach": "Bog‘lash",
  "garageSheet.pay": "To‘lash",
  "garageLifecycle.cleanTitle": "Toza start",
  "garageLifecycle.deactivateTitle": "Garajni o‘chirish",
  "garageLifecycle.cleanWarningLine1": "Raqam tarixi o‘chiriladi",
  "garageLifecycle.cleanWarningLine2": "va uni tiklab bo‘lmaydi!",
  "garageLifecycle.deactivateWarningLine1": "O‘chirilgandan so‘ng faol Garaj",
  "garageLifecycle.deactivateWarningLine2": "funksiyalariga kirish to‘xtaydi",
  "garageLifecycle.willBeDeleted": "O‘CHIRILADI",
  "garageLifecycle.cleanRemovedLine1": "• Bort jurnalidagi barcha yozuvlar",
  "garageLifecycle.cleanRemovedLine2": "• Olingan signallar tarixi",
  "garageLifecycle.cleanRemovedLine3": "• Ommaviy signal hisoblagichlari",
  "garageLifecycle.cleanRemovedLine4": "  raqam kartasida",
  "garageLifecycle.willRemain": "SAQLANADI",
  "garageLifecycle.cleanPreservedLine1": "• Raqamning Garajga bog‘lanishi",
  "garageLifecycle.cleanPreservedLine2": "• Qolgan faollashtirish muddati",
  "garageLifecycle.cleanPreservedLine3": "• Tanlangan raqam statusi",
  "garageLifecycle.cleanPreservedLine4": "• Raqam kartasi umumiy ko‘rishlar soni",
  "garageLifecycle.freeFirstHour": "Birinchi soat bepul",
  "garageLifecycle.willBecomeUnavailable": "MAVJUD BO‘LMAYDI",
  "garageLifecycle.deactivateRemovedLine1": "• Bort jurnali",
  "garageLifecycle.deactivateRemovedLine2": "• Raqam statusini tanlash va ishlatish",
  "garageLifecycle.deactivateRemovedLine3": "• AutoClan’dan avtomatik chiqish",
  "garageLifecycle.deactivateRemovedLine4": "• Avto bozor",
  "garageLifecycle.deactivateRemovedLine5": "• Sug‘urta",
  "garageLifecycle.deactivateRemovedLine6": "• Pit-stop",
  "garageLifecycle.deactivateRemovedLine7": "• Yo‘l yordami",
  "garageLifecycle.deactivateRemovedLine8": "• Davlat raqami Garajdan uziladi",
  "garageLifecycle.willRemainAvailable": "MAVJUD BO‘LIB QOLADI",
  "garageLifecycle.deactivatePreservedLine1": "• Hamroh",
  "garageLifecycle.deactivatePreservedLine2": "• Dispetcher",
  "garageLifecycle.deactivatePreservedLine3": "• Davlat raqami bo‘yicha qidiruv va",
  "garageLifecycle.deactivatePreservedLine4": "  ommaviy avtomobil kartasini ko‘rish",
  "garageLifecycle.deactivatePreservedLine5": "• Istalgan vaqtda Garajni",
  "garageLifecycle.deactivatePreservedLine6": "  qayta faollashtirish imkoniyati",
  "garageLifecycle.cleanConsentLine1": "Ushbu raqamning butun tarixini",
  "garageLifecycle.cleanConsentLine2": "tiklash imkonisiz o‘chirishga",
  "garageLifecycle.cleanConsentLine3": "roziligimni tasdiqlayman.",
  "garageLifecycle.deactivateConsentLine1": "Garajni o‘chirishni va",
  "garageLifecycle.deactivateConsentLine2": "barcha faol Garaj funksiyalariga",
  "garageLifecycle.deactivateConsentLine3": "kirish to‘xtashini tasdiqlayman.",
  "garageLifecycle.clean": "Tozalash",
  "garageLifecycle.deactivate": "O‘chirish",
} satisfies Record<MessageKey, string>
